import {Component, Injectable} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {Title} from "@angular/platform-browser";
import {SignInService} from './modules/auth/sign-in/sign-in.service';
import {parseDomain, ParseResultType} from 'parse-domain';

@Injectable({
    providedIn: 'root'
})

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [
        RouterOutlet
    ],
})

export class AppComponent {

    title: string = "Fuse Angular - Angular Template and Starter Kit";

    /* Constructor */
    constructor(
        private titleService: Title,
        private signInService: SignInService
    ) {
        /* Generate a UUID for each device and store it in the local storage */
        if (!localStorage.getItem('device_uuid')) {
            localStorage.setItem('device_uuid', this.signInService.generateUUID());
        }
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    ngOnInit(): void {
        this.getPageTitle();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    //Function to set the page title
    public getPageTitle() {
        /* Get the current hostname */
        // const hostname = "etrace-eagro.com";
        const hostname = window.location.hostname;

        console.log("Hostname: ", hostname);

        /* Function to parse the root domain */
        const getMainDomain = (hostname: string): string | null => {
            const parseResult = parseDomain(hostname);

            console.log("Parse result: ", parseResult);

            if (parseResult.type === ParseResultType.Listed) {
                const {domain, topLevelDomains} = parseResult;
                return `${domain}.${topLevelDomains.join('.')}`;
            } else if (parseResult.type === ParseResultType.Reserved) {
                return `${parseResult.hostname}`
            }

            return null;
        };

        /* Get the main domain */
        const rootDomain = getMainDomain(hostname);

        this.signInService.getMemberInfo(rootDomain).then((data) => {
            //Set the page title to company_name
            if (data && data.company_name) {
                this.titleService.setTitle(data.company_name);
            }
        }).catch((error) => {
            console.error('Failed to get auth company info.', error);
        });
    }

    //Function to test Sentry error
    public throwTestError(): void {
        throw new Error("Sentry Test Error");
    }
}
